import apiClient from "../../config/apiClient";


export const fetchUpcommingAppointments = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
     return await apiClient.get(`/public/portal?url=patient/dashboard-data/${id}?type=upcomingAppointments%26page=1%26limit=50`, {
        headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
  // /front-desk/appointments?page=1&limit=15&patient_id=27501&startDate=&endDate=